import { default as Keycloak } from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://keycloak-qa.insuranceservices.mx/",
  realm: "amex-local",
  clientId: "ops-client",
});

export default keycloak;
